<template>
  <div class="block">
    <el-pagination
        :current-page="current"
        :layout="layout"
        :page-size="size"
        :pager-count="5"
        :total="total"
        background
        @size-change="sizeChange"
        @current-change="handleCurrent"
        @next-click="handleCurrent"
        @prev-click="handleCurrent"
    />
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Page",
  props: {
    current: Number,
    total: Number,
    size: Number
  },
  computed: {
    ...mapGetters({
      device: 'device',
    }),
    layout() {
      return this.device === 'desktop' ? "total,sizes,prev, pager, next" : "total, pager"
    }
  },
  methods: {
    sizeChange(val) {
      const parentName = this.$parent.$options.name;
      this.refresh.$emit(parentName + "page", function () {
        // eslint-disable-next-line vue/no-mutating-props
        this.size = val;
        this.fetchData();
      })
    },
    handleCurrent(val) {
      const parentName = this.$parent.$options.name;
      this.refresh.$emit(parentName + "page", function () {
        // eslint-disable-next-line vue/no-mutating-props
        this.current = val;
        this.fetchData();
      })
    },
  },
}
</script>
